module.exports = __webpack_public_path__ + "static/media/1200px-Digiturk_logo.c95c7eae.png";